import { VerticalTabWorkList } from "../../secondary/VerticalTabWorkList";
import { useWorkListTabs } from "./hooks/useWorkListTabs";
import { WorklistScreen } from "./worklistScreen";
import { WORKLIST_CONFIG } from "./worklistConfig";

export function OtherAssessments({ facilityNumber }) {
  const { dispatch, defaultVerTab, onSelectVerTab, poaCount, nonpoaCount } = useWorkListTabs(facilityNumber, "otherAssessmentsValues");

  const tabList = [
    {
      name: `POA ${poaCount}`,
      key: "poa",
      content: <WorklistScreen facilityNumber={facilityNumber} config={WORKLIST_CONFIG.otherAssessmentsPOA} />,
      bottomName: "Pending Review",
    },
    {
      name: `Non-POA ${nonpoaCount}`,
      key: "nonPoa",
      content: <WorklistScreen facilityNumber={facilityNumber} config={WORKLIST_CONFIG.otherAssessmentsNONPOA} />,
      bottomName: "Pending Review",
    },
  ];

  return (
    <VerticalTabWorkList onSelectInt={onSelectVerTab} defaultIndex={defaultVerTab <= 1 ? defaultVerTab : 0} tabList={tabList} dispatch={dispatch} />
  );
}
